import Vue from 'vue';
import SkySearch from './sky-search';

// Main component
Vue.component('sky-search', SkySearch);

export default SkySearch;



// WEBPACK FOOTER //
// ./scripts/sky-search/index.js